module.exports = __webpack_public_path__ + "static/img/img-main-features-setcion-1@2x.76fc554.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/img-main-features-setcion-1@2x.png
// module id = uhlZ
// module chunks = 18